"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _apolloClient = require("@/apollo/apolloClient");
var _newsQuery = require("@/apollo/queries/news-query");
var state = {
  newss: [],
  news: [],
  newsDistributions: [],
  newsSurveyAggregate: {},
  newsSurveyAnswers: [],
  searchNewsText: '',
  searchNewsDistribution: ''
};
var mutations = {
  UPDATE_NEWSS: function UPDATE_NEWSS(state, newss) {
    state.newss = newss.map(function (news) {
      return news;
    });
  },
  UPDATE_NEWS_WITH_DISTRIBUTIONS: function UPDATE_NEWS_WITH_DISTRIBUTIONS(state, result) {
    var news = result.news,
      distributions = result.distributions;
    state.news = news.map(function (news) {
      return news;
    });
    state.newsDistributions = distributions.map(function (distribution) {
      return distribution;
    });
  },
  UPDATE_NEWS_WITH_SURVEY_AGGREGATE: function UPDATE_NEWS_WITH_SURVEY_AGGREGATE(state, result) {
    var news = result.news,
      answer_result = result.answer_result,
      answers = result.answers;
    state.news = news.map(function (news) {
      return news;
    });
    state.newsSurveyAggregate = answer_result.reduce(function (aggregate, x) {
      return {
        no_answer: aggregate.no_answer + x.no_answer,
        yes_answer: aggregate.yes_answer + x.yes_answer
      };
    }, {
      no_answer: 0,
      yes_answer: 0
    });
    state.newsSurveyAnswers = answers.map(function (answer) {
      return {
        staff_code: answer.user.id,
        name: answer.user.name
      };
    });
  },
  UPDATE_NEWS_SURVEY_ANSWER: function UPDATE_NEWS_SURVEY_ANSWER(state, answers) {
    state.newsSurveyAnswers = answers.map(function (answer) {
      return answer;
    });
  },
  UPDATE_NEWS: function UPDATE_NEWS(state, news) {
    state.news = news.map(function (news) {
      return news;
    });
  },
  SET_SEARCH_NEWS_TITLE: function SET_SEARCH_NEWS_TITLE(state, val) {
    state.searchNewsText = val;
  },
  SET_SEARCH_NEWS_DISTRIBUTION: function SET_SEARCH_NEWS_DISTRIBUTION(state, val) {
    state.searchNewsDistribution = val;
  }
};
var actions = {
  fetchNewss: function () {
    var _fetchNewss = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
      var commit, _sTitle, _sDescription, _sDistribution, res;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            if (state.searchNewsText) {
              _sTitle = "".concat(state.searchNewsText, "%");
              _sDescription = "%".concat(state.searchNewsText, "%");
            } else {
              _sTitle = null;
              _sDescription = null;
            }
            if (state.searchNewsDistribution) {
              _sDistribution = state.searchNewsDistribution;
            } else {
              _sDistribution = null;
            }
            _context.next = 1;
            return _apolloClient.apolloClient.query({
              query: _newsQuery.NEWSS_LIST_QUERY,
              variables: {
                title: _sTitle,
                description: _sDescription,
                distributionType: _sDistribution
              }
            });
          case 1:
            res = _context.sent;
            commit('UPDATE_NEWSS', res.data.news);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function fetchNewss(_x) {
      return _fetchNewss.apply(this, arguments);
    }
    return fetchNewss;
  }(),
  fetchNewsWithDistributions: function () {
    var _fetchNewsWithDistributions = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2, id) {
      var commit, res;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref2.commit;
            _context2.next = 1;
            return _apolloClient.apolloClient.query({
              query: _newsQuery.NEWS_WITH_DISTRIBUTIONS_QUERY,
              variables: {
                id: id
              },
              fetchPolicy: 'no-cache'
            });
          case 1:
            res = _context2.sent;
            commit('UPDATE_NEWS_WITH_DISTRIBUTIONS', res.data);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function fetchNewsWithDistributions(_x2, _x3) {
      return _fetchNewsWithDistributions.apply(this, arguments);
    }
    return fetchNewsWithDistributions;
  }(),
  fetchNewsWithSurveyAggregate: function () {
    var _fetchNewsWithSurveyAggregate = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref3, id) {
      var commit, res;
      return regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref3.commit;
            _context3.next = 1;
            return _apolloClient.apolloClient.query({
              query: _newsQuery.NEWS_WITH_SURVEY_AGGREGATE_QUERY,
              variables: {
                id: id
              },
              fetchPolicy: 'no-cache'
            });
          case 1:
            res = _context3.sent;
            commit('UPDATE_NEWS_WITH_SURVEY_AGGREGATE', res.data);
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function fetchNewsWithSurveyAggregate(_x4, _x5) {
      return _fetchNewsWithSurveyAggregate.apply(this, arguments);
    }
    return fetchNewsWithSurveyAggregate;
  }(),
  fetchDetail: function () {
    var _fetchDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref4, id) {
      var commit, res;
      return regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref4.commit;
            _context4.next = 1;
            return _apolloClient.apolloClient.query({
              query: _newsQuery.NEWS_QUERY,
              variables: {
                id: id
              },
              fetchPolicy: 'no-cache'
            });
          case 1:
            res = _context4.sent;
            commit('UPDATE_NEWS', res.data.news);
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function fetchDetail(_x6, _x7) {
      return _fetchDetail.apply(this, arguments);
    }
    return fetchDetail;
  }(),
  setSearchNewsText: function () {
    var _setSearchNewsText = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref5, val) {
      var commit;
      return regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            commit = _ref5.commit;
            commit('SET_SEARCH_NEWS_TITLE', val);
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    function setSearchNewsText(_x8, _x9) {
      return _setSearchNewsText.apply(this, arguments);
    }
    return setSearchNewsText;
  }(),
  setSearchNewsDistribution: function () {
    var _setSearchNewsDistribution = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref6, val) {
      var commit;
      return regeneratorRuntime.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            commit = _ref6.commit;
            commit('SET_SEARCH_NEWS_DISTRIBUTION', val);
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    function setSearchNewsDistribution(_x0, _x1) {
      return _setSearchNewsDistribution.apply(this, arguments);
    }
    return setSearchNewsDistribution;
  }()
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};